import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';

const ConfirmationModal = (props) => {
  const { onClose = _.noop(), onConfirm = _.noop() } = props;

  return (
    <React.Fragment>
      <div className="delete-modal-main_page">
        <div className="delete-modal--inner">
          <div className="delete-modal---block_title">
            <div className="inner--block_title">
              <div className="title">Soft Restart</div>
              <p className="sub-title">Are you sure you want to perform a soft restart?</p>
            </div>
          </div>
          <div className="delete-modal-input-box__block">
            <Row>
              <Col lg={6}>
                <Button className="delete-model--btn cancel--btn" onClick={onClose}>
                  Cancel
                </Button>
              </Col>
              <Col lg={6}>
                <Button className="delete-model--btn  remove--btn" onClick={onConfirm}>
                  Confirm
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
ConfirmationModal.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};
export default ConfirmationModal;
